<template>
  <div class="p-the-a01-carousel">
    <template v-if="useCarousel">
      <div class="p-the-a01-carousel__carousel c-swiper">
        <AppSwiper
          ref="mySwiper"
          class="p-the-a01-carousel__carousel__inner"
          :options="swiperOption"
        >
          <SwiperSlide
            v-for="({ image, url, banner_type, categories, premiums },
            key) in carouselItems"
            :key="key"
          >
            <a
              v-touch:tap
              :href="setUrl(banner_type, url, categories, premiums)"
              class="p-the-a01-carousel__carousel__link"
            >
              <img
                class="p-the-a01-carousel__carousel__image"
                :src="image"
                alt
              />
            </a>
          </SwiperSlide>
        </AppSwiper>
        <div class="p-the-a01-carousel__carousel__pagination"></div>
      </div>
    </template>
    <template v-else>
      <div class="p-the-a01-carousel__carousel">
        <div class="p-the-a01-carousel__carousel__inner">
          <a
            :href="carouselItems[0].url"
            class="p-the-a01-carousel__carousel__link"
          >
            <img
              class="p-the-a01-carousel__carousel__image"
              :src="carouselItems[0].image"
              alt
            />
          </a>
        </div>
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import globals from "@/general/store/modules/globals";

import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  SwiperOptions
} from "swiper";
import { Options, Vue } from "vue-class-component";
// Swiper modules
SwiperClass.use([Pagination, Mousewheel, Autoplay]);

@Options({
  props: {
    carouselItems: {
      type: Array,
      required: false
    }
  },
  components: {
    Swiper,
    SwiperSlide
  }
})
export default class TheA01Carousel extends Vue {
  carouselItems!: any;

  swiperOption = {
    loop: true,
    autoplay: {
      delay: 5000
    },
    speed: 1000,
    centeredSlides: true,
    pagination: {
      el: ".p-the-a01-carousel__carousel__pagination",
      clickable: true
    },
    breakpoints: {
      769: {
        loopFillGroupWithBlank: true,
        slidesPerView: 1.3
      }
    }
  };

  get isSp(): boolean {
    return globals.isLargeBreakpointWidthOfSp;
  }

  get useCarousel() {
    return this.carouselItems.length > 1;
  }

  setUrl(bannerType: number, url: any, categories: any, premiums: any) {
    if (bannerType == 1) {
      return "/product-list/?product-category=" + categories.join();
    } else if (bannerType == 2) {
      if (premiums.length > 1) {
        return "/product-list/?premiums=" + premiums.join();
      } else {
        return "/product-details/?id=" + premiums[0];
      }
    } else {
      return url;
    }
  }
}
</script>

<style lang="scss" scoped>
.p-the-a01-carousel {
  @include pc {
    height: vw(352, 1110);
    max-height: rem(352);
    min-width: rem($min-width--m);
  }

  @include sp {
    height: vw(120, 320);
    max-height: rem(288);
    min-width: rem($min-width--s);
  }

  overflow-y: hidden;
  position: relative;

  .swiper-slide {
    display: flex;
  }

  &__carousel {
    display: flex;
    width: 100%;
    height: 100%;

    &__inner {
      position: relative;
      width: 100%;
      height: 100%;
    }

    &__link {
      display: block;
      width: 100%;
      height: 100%;

      &.tap {
        opacity: 0.5;
      }
    }

    &__image {
      @include object-fit("contain");
      width: 100%;
      height: 100%;
    }

    &__image:hover {
      opacity: 0.4;
    }

    &__pagination {
      @include pc {
        bottom: rem(20);
      }
      @include sp {
        bottom: rem(6);
      }
      width: 100%;
      position: absolute;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
    }
  }
}
</style>
